import { useAuth } from './useAuth';

export const useUser = () => {
  const { getUserData } = useAuth();
  const userData = getUserData();

  return {
    username: userData?.user || '',
    handler: userData?.handler || '',
    isAdmin: userData?.admin || false,
    isCaptain: userData?.capitan || false,
    system: userData?.sistema_origen || '',
    planet: userData?.planeta_origen || '',
    reputation: userData?.reputacion_corvus || 0,
    organizations: userData?.organizaciones || []
  };
}; 